import { render, staticRenderFns } from "./EventDashboardComponent.vue?vue&type=template&id=c22f0078&"
import script from "./EventDashboardComponent.vue?vue&type=script&lang=js&"
export * from "./EventDashboardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports